import { HOME } from "@/routing";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Typography from "@mui/joy/Typography";
import { useLocation } from "wouter";

interface ErrorPageProps {
  statusCode?: number;
}

export default function ErrorPage({ statusCode = 404 }: ErrorPageProps) {
  const [, setLocation] = useLocation();

  const messages: Record<number, { title: string; message: string }> = {
    404: {
      title: "Page Not Found",
      message: "The page you're looking for doesn't exist.",
    },
    500: {
      title: "Server Error",
      message: "Something went wrong on our end. Please try again later.",
    },
  };

  const { title, message } = messages[statusCode] || messages[404];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 2,
        p: 3,
      }}
    >
      <Typography level="h1" sx={{ fontSize: "4rem", fontWeight: "bold" }}>
        {statusCode}
      </Typography>
      <Typography level="h2">{title}</Typography>
      <Typography
        level="body-md"
        sx={{ textAlign: "center", maxWidth: "400px" }}
      >
        {message}
      </Typography>
      <Button onClick={() => setLocation(HOME)} sx={{ mt: 2 }}>
        Go Home
      </Button>
    </Box>
  );
}
